import { EMPTY_LIST } from '../../../../../constants/common'
import { MOCK_VIEWINGS_PERMISSIONS } from '../../../../RentalPortalViewing'

export const EMPTY_ITEMS = {
  items: EMPTY_LIST,
  permissions: MOCK_VIEWINGS_PERMISSIONS,
}
